import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-08df467e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "table-container-wrapper"
};
const _hoisted_5 = {
  class: "table-top-flex"
};
const _hoisted_6 = {
  class: "table-title"
};
const _hoisted_7 = {
  key: 0,
  class: "button-container"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
const _hoisted_9 = {
  class: "dialog-footer"
};
import { listRole, getRole, getRoleForm, menusOptions, delRole, addRole, updateRole, dataScope } from "@/api/system1/role";
import { treeselect as menuTreeselect, roleMenuTreeselect } from "@/api/system1/menu";
import { ref, unref, reactive, toRefs, watch, onMounted, nextTick, computed } from "vue";
import { ElMessageBox, ElMessage } from 'element-plus';
import { getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
export default {
  __name: 'index',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const form1 = ref(null);
    const form = ref(null);
    const router = useRouter();

    // 获取路由名称作为表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '角色管理';
    });
    // 状态数据字典
    const statusOptions = ref([{
      dictValue: 1,
      dictLabel: "正常"
    }, {
      dictValue: 0,
      dictLabel: "停用"
    }]);
    // 数据范围选项
    const dataScopeOptions = ref([{
      value: 0,
      label: "全部数据权限"
    }, {
      value: 1,
      label: "自定数据权限"
    }, {
      value: 2,
      label: "本部门数据权限"
    }, {
      value: 3,
      label: "本部门及以下数据权限"
    }]);
    const defaultProps = ref({
      children: "children",
      label: "label"
    });
    // 菜单列表
    const menuOptions = ref([]);
    // 部门列表
    const deptOptions = ref([]);
    const state = reactive({
      // 遮罩层
      loading: true,
      openLoading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 角色表格数据
      roleList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否显示弹出层（数据权限）
      openDataScope: false,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        keywords: ''
      },
      // 表单参数
      form: {
        code: '',
        dataScope: 0,
        id: '',
        name: '',
        sort: '',
        status: ''
      },
      form1: {
        permKeywords: '',
        roleId: ''
      },
      // 表单校验
      rules: {
        name: [{
          required: true,
          message: "角色名称不能为空",
          trigger: "change"
        }],
        code: [{
          required: true,
          message: "权限字符不能为空",
          trigger: "change"
        }],
        dataScope: [{
          required: true,
          message: "数据权限不能为空",
          trigger: "change"
        }],
        status: [{
          required: true,
          message: "状态不能为空",
          trigger: "change"
        }]
      },
      saveLoading: false,
      searchFormData: [{
        prop: "keywords",
        label: "角色名称",
        placeholder: "请输入角色名称查询",
        type: "text",
        isSelect: false,
        span: 4
      }],
      formHandle: [{
        label: "搜索",
        type: "primary",
        icon: "el-icon-search",
        class: "btn-liquid",
        handle: () => handleQuery()
      }, {
        label: "重置",
        icon: "el-icon-refresh",
        class: "commonDarkBtn",
        handle: () => resetQuery()
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "新增",
        buttonStyle: "primary",
        hasPermi: ['sys:role:add'],
        className: 'addBtn',
        buttonIcon: "Plus",
        exp: item => handleAdd(item)
      }, {
        buttonName: "删除",
        buttonStyle: "danger",
        hasPermi: ['sys:role:delete'],
        className: 'deleteBtn',
        buttonIcon: "Delete",
        exp: item => handleDelete(item),
        disabledHandle(row) {
          return state.multiple;
        }
      }],
      tableHeader: [{
        prop: "id",
        label: "角色编号"
      }, {
        prop: "name",
        label: "角色名称"
      }, {
        prop: "code",
        label: "权限字符"
      },
      // {
      //   prop: "sort",
      //   label: "显示顺序",
      // },
      {
        prop: "status",
        label: "状态",
        statusList: [{
          value: 1,
          label: "正常"
        }, {
          value: 0,
          label: "停用"
        }]
      }, {
        prop: "createTime",
        label: "创建时间"
      }, {
        prop: "operation",
        label: "操作",
        width: "200px",
        fixed: "right",
        operation: [{
          name: '修改',
          clickFun: row => handleUpdate(row),
          hasPermi: ['sys:role:edit'],
          disabledHandle(row) {
            return row.code === 'root';
          }
        }, {
          name: '分配权限',
          clickFun: row => handleDataScope(row),
          hasPermi: ['sys:role:menus'],
          disabledHandle(row) {
            return row.code === 'root';
          }
        }, {
          name: '删除',
          clickFun: row => handleDelete(row),
          hasPermi: ['sys:role:delete'],
          disabledHandle(row) {
            return row.code === 'admin';
          }
        }]
      }],
      formData: [{
        prop: "permKeywords",
        label: "菜单权限",
        placeholder: "请选择菜单权限",
        type: "elTree",
        nodeKey: 'value',
        props: defaultProps,
        isSelect: false,
        options: menuOptions,
        span: 24
      }],
      formScopeData: [{
        prop: "name",
        label: "角色名称",
        placeholder: "请输入角色名称",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "code",
        label: "权限字符",
        placeholder: "请输入权限字符",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "dataScope",
        label: "数据权限",
        placeholder: "请选择查询权限",
        type: "list",
        options: dataScopeOptions,
        props: {
          label: "label",
          value: "value"
        },
        isSelect: false,
        disabled: true,
        span: 24
      }, {
        prop: "status",
        label: "状态",
        placeholder: "请选择状态",
        type: "radio",
        isSelect: false,
        options: statusOptions,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        span: 24
      }, {
        prop: "sort",
        label: "排序",
        placeholder: "请输入排序",
        type: "textNum",
        isSelect: false,
        span: 24
      }]
    });
    onMounted(() => {
      // 有问题
      // proxy.getDicts("sys_normal_disable").then(response => {
      //   statusOptions.value = response.data;
      // });
    });
    /** 查询角色列表 */
    const getList = function () {
      state.loading = true;
      listRole(state.queryParams).then(response => {
        state.roleList = {
          rows: response.data.list,
          total: response.data.total
        };
        state.loading = false;
      });
    };
    /** 查询菜单树结构 */
    const getMenuTreeselect = function () {
      menusOptions().then(response => {
        menuOptions.value = response.data;
        getRole(state.form1.roleId).then(response => {
          state.form1.permKeywords = response.data;
          let arr = [];
          if (response.data.length > 0) {
            response.data.forEach(id => {
              // console.log(form1.value.menu[0].data,'childNodes--',id)
              // console.log(form1.value.menu[0].getNode(id),'childNodes--')
              // console.log(form1.value.menu[0].getNode(id).childNodes,'childNodes')
              const node = form1.value.menu[0].getNode(id);
              if (node && (!node.childNodes || !node.childNodes.length)) {
                arr.push(id);
              }
            });
            form1.value.menu[0].setCheckedKeys(arr);
          }
          state.openLoading = false;
        }).catch(error => {
          state.openLoading = false;
        });
      });
    };
    // 所有菜单节点数据
    const getMenuAllCheckedKeys = function () {
      // 目前被选中的菜单节点
      let checkedKeys = form1.value.menu[0].getHalfCheckedKeys();
      // 半选中的菜单节点
      let halfCheckedKeys = form1.value.menu[0].getCheckedKeys();
      console.log(halfCheckedKeys, 'halfCheckedKeys');
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    };

    // 取消按钮
    const cancel = function () {
      state.open = false;
      // reset();
    };
    // 取消按钮（数据权限）
    const cancelDataScope = function () {
      state.openDataScope = false;
      // reset();
    };
    // 表单重置
    const reset = function () {
      // if (form.value.menu[0] != undefined) {
      //      form.value.menu[0].setCheckedKeys([]);
      //     }
      state.form = {
        code: '',
        dataScope: 0,
        id: '',
        name: '',
        sort: '',
        status: ''
      };
      // resetForm("form");
    };
    /** 搜索按钮操作 */
    const handleQuery = function () {
      state.queryParams.pageNum = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = function () {
      state.dateRange = [];
      // state.resetForm("queryForm");
      //bug 8037  U-功能测试-系统中心-所有查询输入框重置功能无效 mosen 2021/9/1
      state.queryParams = {
        pageNum: 1,
        pageSize: 10,
        keywords: undefined
      };
      handleQuery();
    };
    // 多选框选中数据
    const handleSelectionChange = function (selection) {
      state.ids = selection.map(item => item.id);
      state.single = selection.length != 1;
      state.multiple = !selection.length;
    };
    /** 新增按钮操作 */
    const handleAdd = function () {
      state.openDataScope = true;
      state.title = "添加角色";
      reset();
    };
    /** 修改按钮操作 */
    const handleUpdate = function (row) {
      state.title = "修改角色";
      reset();
      const roleId = row.id;
      state.openDataScope = true;
      getRoleForm(roleId).then(response => {
        state.form = response.data;
        state.form.dataScope = 0;
      });
    };
    /** 分配数据权限操作 */
    const handleDataScope = function (row) {
      state.open = true;
      state.openLoading = true, state.title = "分配数据权限";
      reset();
      nextTick(() => {
        getMenuTreeselect();
        state.form1.roleId = row.id;
      });
    };
    /** 分配权限提交按钮 */
    const submitForm = function () {
      if (state.form1.roleId != undefined) {
        const formRef = unref(form1);
        state.form1.permKeywords = getMenuAllCheckedKeys();
        dataScope(state.form1).then(response => {
          if (response.code == 0) {
            ElMessage.success("分配成功");
            state.open = false;
            getList();
          } else {
            ElMessage.error(response.msg);
          }
        });
      }
    };
    /** 修改/新增角色提交按钮*/
    const submitDataScope = function () {
      const formRef = unref(form);
      formRef.commonForm.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          if (state.form.id) {
            updateRole(state.form).then(response => {
              if (response.code == 0) {
                ElMessage.success("修改成功");
                state.openDataScope = false;
                getList();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          } else {
            addRole(state.form).then(response => {
              if (response.code == 0) {
                ElMessage.success("新增成功");
                state.openDataScope = false;
                //新增后重置
                resetQuery();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          }
        }
      });
    };
    /** 删除按钮操作 */
    const handleDelete = function (row) {
      const roleIds = row.id || state.ids;
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认删除数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return delRole(roleIds);
      }).then(res => {
        getList();
        ElMessage.success("删除成功");
      }).catch(function () {});
    };
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: state.queryParams,
        formData: state.searchFormData,
        formHandle: state.formHandle
      }, null, 8, ["form", "formData", "formHandle"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Iconfont, {
        name: "role",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          loading: item.loading,
          icon: item.buttonIcon,
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, form.value),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "loading", "icon", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.roleList,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        multipleSelection: state.ids,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.ids = $event),
        onGetList: getList,
        hasSelect: true,
        columnSetting: false,
        onSelectionChange: handleSelectionChange
      }, null, 8, ["tableData", "tableHeader", "queryParams", "multipleSelection"]), [[_directive_loading, state.loading]])]), _createVNode(_component_commonDrawer, {
        modelValue: state.open,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.open = $event),
        size: "600px",
        title: "分配权限",
        "close-on-click-modal": false,
        onClose: cancel
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_withDirectives(_createVNode(_component_commonForm, {
          ref_key: "form1",
          ref: form1,
          form: state.form1,
          formRules: state.rules,
          formData: state.formData,
          isHandle: false
        }, null, 8, ["form", "formRules", "formData"]), [[_directive_loading, state.openLoading]])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_commonDrawer, {
        modelValue: state.openDataScope,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.openDataScope = $event),
        size: "600px",
        title: state.title,
        "close-on-click-modal": false,
        onClose: cancelDataScope
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitDataScope
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: cancelDataScope
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_commonForm, {
          ref_key: "form",
          ref: form,
          form: state.form,
          formRules: state.rules,
          formData: state.formScopeData,
          isHandle: false
        }, null, 8, ["form", "formRules", "formData"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};